
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Admin_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 34.1 36.95","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Admin_svg__st0",attrs:{"d":"M15.96 14.63h5.09v1h-5.09zM10.56 17.69h10.48v1H10.56zM10.56 20.75h10.48v1H10.56z"}}),_c('path',{staticClass:"Admin_svg__st0",attrs:{"d":"M34.1 21.65V14.5h-3.84c-.36-1.39-.93-2.71-1.76-4.05l2.72-2.63-5.09-5.03-2.51 2.75c-1.31-.8-2.63-1.37-4.02-1.73V0h-7.15v3.77c-2.11.37-3.22.99-4.49 1.8L4.21 2.04.37 16.44l-.05.2 14.85-1.98-2.94-2.94c.65-.47 1.85-1.16 3.38-1.16 4.37 0 7.93 3.56 7.93 7.93s-3.56 7.93-7.93 7.93a7.91 7.91 0 01-7.9-7.14l-.01-.13-1.18.12.01.14a9.077 9.077 0 009.07 8.21c5.03 0 9.12-4.09 9.12-9.12s-4.09-9.12-9.12-9.12c-2.78 0-4.61 1.8-4.68 1.88l-.42.42 2.13 2.13-10.72 1.43L4.84 4.26l3 2.81.4-.26c1.42-.93 2.45-1.6 4.9-1.95l.51-.08v-3.6h4.78v3.57l.46.1c1.57.34 3.05.98 4.52 1.94l.42.28 2.35-2.58 3.35 3.31-2.55 2.46.27.41c.98 1.5 1.63 2.99 1.97 4.54l.1.46h3.61v4.79h-3.64l-.07.51c-.35 2.38-1.01 3.4-1.93 4.8l-.31.47 2.53 2.75-3.46 3.41-2.67-2.56-.39.26c-1.42.93-2.45 1.6-4.9 1.96l-.51.07v3.64H12.8v-3.6l-.46-.1c-1.53-.34-3.01-.98-4.52-1.97l-.42-.27-2.34 2.55-3.36-3.37 2.56-2.56-.26-.4c-.98-1.46-1.65-3.05-2-4.73l-.03-.14-1.16.24.03.14c.35 1.67.98 3.25 1.88 4.73L0 29.01l5.07 5.08 2.51-2.73c1.35.83 2.67 1.4 4.02 1.75v3.84h7.15v-3.81c2.12-.37 3.26-1.01 4.48-1.8l2.82 2.71 5.09-5.03-2.68-2.91c.84-1.29 1.46-2.4 1.83-4.47h3.81z"}})])
          )
        }
      }
    